import { fg } from '@atlassian/jira-feature-gating';

const NavBoardHeaderFragmentRelayProvider = {
	get(): boolean {
		return fg('sea-4095-nav-board-header-fragment');
	},
};

export default NavBoardHeaderFragmentRelayProvider;
